import React from 'react';
import useExploreStore from '../../contexts/useExploreStore';

const HistoryArea = () => {
  const { history, setCurrentQuery, removeFromHistory } = useExploreStore();

  const handleHistoryClick = (query) => {
    setCurrentQuery(query); // Set the current query to the clicked history item
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">History</h2>
      {history.length === 0 ? (
        <p>No history available.</p>
      ) : (
        <ul className="space-y-2">
          {history.map((entry, index) => (
            <li key={index} className="flex justify-between items-center text-sm border-b pb-2">
              <span
                className="cursor-pointer hover:text-blue-500"
                onClick={() => handleHistoryClick(entry.query)}
              >
                {entry.query.length > 20 ? `${entry.query.slice(0, 20)}...` : entry.query}
              </span>
              <button
                className="text-gray-400 hover:text-red-500 focus:outline-none"
                onClick={() => removeFromHistory(index)} // Call the delete function
              >
                <i className="bi bi-trash"></i> {/* Bootstrap trash icon */}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default HistoryArea;
